import { render, staticRenderFns } from "./activityInvigilatorDashboard.html?vue&type=template&id=5c84bc40&scoped=true&external"
import script from "./activityInvigilatorDashboard.vue?vue&type=script&lang=js"
export * from "./activityInvigilatorDashboard.vue?vue&type=script&lang=js"
import style0 from "./activityInvigilatorDashboard.css?vue&type=style&index=0&id=5c84bc40&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84bc40",
  null
  
)

export default component.exports